<header class="pc-header">
  <div class="header-wrapper">
    <div class="pc-mob-drp">
      <app-nav-left [navCollapsed]="navCollapsed" (NavCollapse)="navCollapse()" (NavCollapsedMob)="navCollapseMob()"></app-nav-left>
    </div>
        <div class="header-center">
          @if(upcomminvac > 0 && muestro){
      <span class="header-message">Próximos Días Libres {{upcomminvac}}</span> &nbsp; &nbsp;
      <!--  (click)="goto()" -->
       <button class="header-action-btn" (click)="goto()">🔔 Ver</button>
        }
    </div>
    <div>
      <app-nav-right />
    </div>
  </div>
</header>
